import * as React from 'react'
import { useState } from 'react'
import {
    ActionButton,
    DialogFooter,
    IDialogProps,
    Label,
    PrimaryButton,
    Stack,
    StackItem,
    Text,
    TextField,
} from '@fluentui/react'
import LegacyBaseDialog from '../LegacyBaseDialog'
import { formatInputDocumentName } from '../../../helpers/regexHelper'
import useAxios from '../../../hooks/useAxios'
import { Destination } from '../../../context/AxiosContext'
import { IDocumentStackItemDto, IFolderOverviewItemDto } from '../../../config/documentConfig'
import { useTranslation } from 'react-i18next'

type Props = IDialogProps & {
    isRoot: boolean
    parent: IFolderOverviewItemDto
    reset: (stack?: IDocumentStackItemDto[]) => void
}

export default function CreateFolderDialog(props: Props) {
    const axios = useAxios()
    const { t: translate } = useTranslation()

    const [name, setName] = useState<string>('')
    const title = translate(
        props.isRoot ? 'file.pivot.documents.create.folder.root' : 'file.pivot.documents.create.folder.sub',
    )

    return (
        <LegacyBaseDialog dialogContentProps={{ title }} {...props}>
            <Stack tokens={{ childrenGap: 's1' }}>
                {!props.isRoot && (
                    <StackItem>
                        <Label>{translate('file.pivot.documents.create.folder.parent')}</Label>
                        <Text>{props.parent.name}</Text>
                    </StackItem>
                )}
                <StackItem>
                    <TextField
                        autoFocus
                        label={translate('file.pivot.documents.create.folder.name')}
                        value={name}
                        onChange={(_, value?: string) => setName(formatInputDocumentName(value))}
                    />
                </StackItem>
            </Stack>
            <DialogFooter>
                <PrimaryButton
                    text={translate('file.pivot.documents.create.folder.submit')}
                    disabled={!name}
                    onClick={() =>
                        axios
                            .post(
                                `/items/${props.parent.id}/children`,
                                { folder: {}, name },
                                { baseURL: Destination.Documents },
                            )
                            .then(() => {
                                props.onDismiss()
                                props.reset([...props.parent.stack, { id: props.parent.id, name: props.parent.name }])
                            })
                    }
                />
                <ActionButton text={translate('action.cancel')} onClick={props.onDismiss} />
            </DialogFooter>
        </LegacyBaseDialog>
    )
}
